import { styled } from "@mui/material/styles";
import { Link as routerLink } from "react-router-dom";
import { Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

export const StyledRoot = styled("div")(({ theme }) => ({
  display: "flex",
  height: "100vh",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
    height: "100dvh",
    minHeight: "100dvh",
    overflow: "auto",
  },
}));

export const StyledMain = styled("div")(({ theme }) => ({
  flex: "0 0 42%",
  maxWidth: 620,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  overflow: "auto",
  [theme.breakpoints.down("md")]: {
    flex: "1 1 auto",
    maxWidth: "100%",
    width: "100%",
    height: "100%",
    minHeight: "100dvh",
  },
}));

export const FormContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  flex: 1,
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    flex: 1,
    minHeight: 0,
    justifyContent: "center",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export const StyledSection = styled("div")(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  overflow: "hidden",
}));

export const StyledContent = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: 480,
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  flex: 1,
  gap: theme.spacing(3),
  [theme.breakpoints.down("md")]: {
    minHeight: "100%",
    gap: theme.spacing(2),
  },
}));

export const TitleWrapper = styled("div")(({ theme }) => ({
  textAlign: "-webkit-center",
  padding: "0px 20px",
}));

export const SignUp = styled(routerLink)(({ theme }) => ({
  minWidth: "150px",
  marginLeft: "auto",
  borderRadius: "25px",
  backgroundColor: theme.palette.secondary.main,
  padding: "10px",
  border: "1px solid",
  color: theme.palette.secondary.contrastText,
  textDecoration: "none",
  textAlign: "-webkit-center",
  transition: "transform 0.3s ease-in-out",

  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.secondary.contrastText,
    transform: "scale(1.1)",
  },
}));

export const StyledLink = styled(routerLink)(({ theme }) => ({
  margin: 0,
  fontWeight: 600,
  lineHeight: 1.5714285714285714,
  fontSize: "0.875rem",
  fontFamily: "Public Sans,sans-serif",
  color: theme.palette.secondary.main,
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underLine",
  },
}));

export const StyledGoogleButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#F4F8FA",
  borderRadius: "25px",
  boxShadow: "none",
  // '&:hover': {
  //   backgroundColor: '#313131d6',
  // },
}));

export const StyledLoadingButton = styled(LoadingButton)(({ theme }) => ({
  backgroundColor: "#313131",
  borderRadius: "25px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#313131d6",
  },
}));

export const StyledBackButton = styled(Button)(({ theme }) => ({
  marginTop: "18px",
  textTransform: "none",
  backgroundColor: "#DFE3E8",
  color: "#212B36",
  borderRadius: "25px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#C4CDD5",
  },
}));
